import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import ProtectedRoute from "./components/ProtectedRoute";

import NewsPage from "./pages/NewsPage";
import PromotionsPage from "./pages/PromotionsPage";
import VacanciesPage from "./pages/VacanciesPage";
import StationsPage from "./pages/StationsPage";
import GalleryPage from "./pages/GalleryPage";
import UsefullInfoPage from "./pages/UsefullInfoPage";
import SocialActivitiesPage from "./pages/SocialActivitiesPage";
import StateProcurementPage from "./pages/StateProcurementPage";
import FuelPricesPage from "./pages/FuelPricesPage";
import LoginPage from "./pages/LoginPage";
import ErrorPage from "./pages/ErrorPage";

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<LoginPage />} />

          <Route
            path="/news"
            element={
              <ProtectedRoute>
                <NewsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/promotions"
            element={
              <ProtectedRoute>
                <PromotionsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/vacancies"
            element={
              <ProtectedRoute>
                <VacanciesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/stations"
            element={
              <ProtectedRoute>
                <StationsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/gallery"
            element={
              <ProtectedRoute>
                <GalleryPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/usefull_info"
            element={
              <ProtectedRoute>
                <UsefullInfoPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/social_activities"
            element={
              <ProtectedRoute>
                <SocialActivitiesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/state_procurement"
            element={
              <ProtectedRoute>
                <StateProcurementPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/fuel_prices"
            element={
              <ProtectedRoute>
                <FuelPricesPage />
              </ProtectedRoute>
            }
          />

          <Route path="/error/404" element={<ErrorPage />} />

          <Route path="*" element={<ErrorPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
